import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { AlertService, VideoService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { appConfig } from "../app.config";

class Video {
  id: number;
  name: string;
  video_type: string;
  video_file: string;
  video_thumb: string;
  category_id: number;
  vartical_ids: string;
  sector_of_business: string;
  sectorofenterprise: string;
  areaofinterest: string;
  areaofstudy: string;
  state: number;
  city: number;
  home_display: string;
  is_active: string;
  video_url: string;
}

@Component({
  selector: "app-video",
  templateUrl: "./video.component.html",
})
export class VideoComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() allowMultiple: boolean;
  @Input() fileType: string = ".jpg , .png , .bmp";
  @Input() videoType: string = ".mp4 , .ogg, .webm";
  @Input() required: boolean;
  @Input() maxSizeInKb: number;
  @Output() onSelection = new EventEmitter<FileList>();
  DisplayedText: string = "";
  thumbnailDisplayedText: string = "";
  isEditMode: boolean = false;
  originalThumb: string = "";
  fileList: any;
  fileList1: any;
  pdf = false;
  croppedVideo: any;
  exl = false;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [7], orderable: false }],
  };
  dtTrigger = new Subject();
  videoList: Video[] = [];
  isSubmitted = false;

  getVideo = {
    id: "",
    name: "",
    video_type: "",
    video_file: "",
    video_thumb: "",
    video_url: "",
    category_id: "",
    vartical_ids: "",
    sector_of_business: "",
    sectorofenterprise: "",
    areaofinterest: "",
    areaofstudy: "",
    state: "",
    city: "",
    home_display: "",
    is_active: "",
  };

  closeResult: string; // Modal Close
  selectedToEnterprise: any;
  myStringEnterprise: any;
  myArrayEnterprise: any;
  selectedToInterest: any;
  myStringInterest: any;
  myArrayInterest: any;
  selectedToStudy: any;
  myStringStudy: any;
  myArrayStudy: any;
  selectedTo: any;
  selectedToVertical: any;
  myStringVertical: any;
  myArrayVertical: any;
  myString: any;
  myArray: any;
  url: any = "https://nitistg.s3.ap-south-1.amazonaws.com";

  constructor(
    public router: Router,
    private dataService: VideoService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}

  video = {
    id: "",
    name: "",
    video_type: "",
    video_file: "",
    video_url: "",
    video_thumb: "",
    category_id: "",
    vartical_ids: "",
    sector_of_business: "",
    sectorofenterprise: "",
    areaofinterest: "",
    areaofstudy: "",
    state: "",
    city: "",
    home_display: "",
    is_active: "",
  };

  modalReference: NgbActiveModal;
  modalTitle: string;
  verticals = {};
  states = {};
  cities = {};
  cat = {};
  AreaSectorOfBusiness = {};
  sectorofenterprise = {};
  areaofinterest = {};
  areaofstudy = {};
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    this.allVideo();
    this.dataService
      .getAllState()
      .pipe()
      .subscribe((data) => {
        this.states = data["state"];
      });
    this.dataService
      .getAllCity()
      .pipe()
      .subscribe((data) => {
        this.cities = data["state"];
      });
    this.dataService
      .getActiveVertical()
      .pipe()
      .subscribe((data) => {
        this.verticals = data["verticals"];
      });
    this.dataService
      .getActiveAreaSectorOfBusiness()
      .pipe()
      .subscribe((data) => {
        this.AreaSectorOfBusiness = data["AreaSectorOfBusiness"];
      });
    this.dataService
      .getSectorofEnterprise()
      .pipe()
      .subscribe((data) => {
        this.sectorofenterprise = data["sectorofenterprise"];
      });
    this.dataService
      .getAreaofInterest()
      .pipe()
      .subscribe((data) => {
        this.areaofinterest = data["areaofinterest"];
      });
    this.dataService
      .getAreaofStudy()
      .pipe()
      .subscribe((data) => {
        this.areaofstudy = data["area_of_study"];
      });
    this.dataService
      .getCategory()
      .pipe()
      .subscribe((data) => {
        this.cat = data["cat"];
      });
  }

  changeToVertical() {
    this.video.vartical_ids = this.selectedToVertical;
  }

  changeTo() {
    this.video.sector_of_business = this.selectedTo;
  }

  changeToEnterprise() {
    this.video.sectorofenterprise = this.selectedToEnterprise;
  }

  changeToInterest() {
    this.video.areaofinterest = this.selectedToInterest;
  }

  changeToStudy() {
    this.video.areaofstudy = this.selectedToStudy;
  }

  allVideo() {
    this.loadShow();
    this.dataService
      .getAllVideo()
      .pipe()
      .subscribe((data) => {
        this.videoList = data["videos"];
        this.rerender();
        this.pdf = true;
        this.exl = true;
        this.loadHide();
      });
  }

  selectCityById(id) {
    this.dataService
      .getCityById(id)
      .pipe()
      .subscribe((data) => {
        this.cities = data["city"];
      });
  }

  open(content) {
    this.isSubmitted = false;
    this.isEditMode = false;
    if (this.getVideo.id != null) {
      this.getVideo.id = "";
    }

    this.selectedTo = "";
    this.selectedToVertical = "";
    this.selectedToInterest = "";
    this.selectedToEnterprise = "";
    this.selectedToStudy = "";

    this.video.id = "";
    this.video.name = "";
    this.video.video_type = "";
    this.video.video_file = "";
    this.video.video_url = "";
    this.video.video_thumb = "";
    this.video.category_id = "";
    this.video.vartical_ids = "";
    this.video.sector_of_business = "";
    this.video.sectorofenterprise = "";
    this.video.areaofinterest = "";
    this.video.areaofstudy = "";
    this.video.state = "";
    this.video.city = "";
    this.video.home_display = "N";
    this.video.is_active = "Y";
    this.DisplayedText = "";
    this.thumbnailDisplayedText = "";
    this.modalTitle = "Add Video";

    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  save(val, f) {
    this.isSubmitted = true;
    if (this.isFieldsInvalid(this.video.name)) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (
      this.video.video_type === "1" &&
      this.isFieldsInvalid(this.video.video_url)
    ) {
      this.alertService.error("Video URL is required");
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (this.video.video_type === "2" && !this.croppedVideo) {
      this.alertService.error("Video File is required");
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (
      !this.isEditMode &&
      (!this.thumbnailDisplayedText ||
        this.thumbnailDisplayedText.trim() === "")
    ) {
      this.alertService.error("Thumbnail is required");

      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (f.form.valid) {
      this.loadShow();
      this.insertAction(val, f);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  edit(id, content) {
    this.loadShow();
    this.video.video_file = "";
    this.isEditMode = true;
    this.DisplayedText = "";
    this.thumbnailDisplayedText = "";
    this.dataService.getVideo(id).subscribe((data) => {
      this.getVideo = data["videos"];
      console.log(this.getVideo, "getVideo");
      this.originalThumb = this.getVideo.video_thumb;
      this.selectCityById(this.getVideo.state);
      let video_files;
      let video_urls;
      if (this.getVideo.video_url == "undefined") {
        this.getVideo.video_url = "";
      } else {
        if (this.getVideo.video_type == "1") {
          video_urls = this.getVideo.video_url;
        } else {
          video_files = this.getVideo.video_url;
        }
      }

      this.myStringVertical = this.getVideo.vartical_ids;
      if (this.myStringVertical) {
        this.myArrayVertical = this.myStringVertical.split(",").map(Number);
        this.selectedToVertical = this.myArrayVertical;
      }

      this.myString = this.getVideo.sector_of_business;
      if (this.myString) {
        this.myArray = this.myString.split(",").map(Number);
        this.selectedTo = this.myArray;
      }

      this.myStringEnterprise = this.getVideo.sectorofenterprise;
      if (this.myStringEnterprise) {
        this.myArrayEnterprise = this.myStringEnterprise.split(",").map(Number);
        this.selectedToEnterprise = this.myArrayEnterprise;
      }

      this.myStringInterest = this.getVideo.areaofinterest;
      if (this.myStringInterest) {
        this.myArrayInterest = this.myStringInterest.split(",").map(Number);
        this.selectedToInterest = this.myArrayInterest;
      }

      this.myStringStudy = this.getVideo.areaofstudy;
      if (this.myStringStudy) {
        this.myArrayStudy = this.myStringStudy.split(",").map(Number);
        this.selectedToStudy = this.myArrayStudy;
      }

      this.video = {
        id: this.getVideo.id,
        name: this.getVideo.name,
        video_type: this.getVideo.video_type,
        video_file: video_files,
        video_url: video_urls,
        video_thumb: this.getVideo.video_thumb,
        vartical_ids: this.getVideo.vartical_ids,
        category_id: this.getVideo.category_id,
        sector_of_business: this.getVideo.sector_of_business,
        sectorofenterprise: this.getVideo.sectorofenterprise,
        areaofinterest: this.getVideo.areaofinterest,
        areaofstudy: this.getVideo.areaofstudy,
        state: this.getVideo.state,
        city: this.getVideo.city,
        home_display: this.getVideo.home_display,
        is_active: this.getVideo.is_active,
      };
      this.loadHide();
      this.modalTitle = "Edit Video";
      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  insertAction(val, f) {
    let formData: FormData = new FormData();

    formData.append("name", this.video.name);
    formData.append("video_type", this.video.video_type);
    formData.append("category_id", this.video.category_id);
    formData.append("sectorofenterprise", this.selectedToEnterprise.join(","));
    formData.append("areaofinterest", this.selectedToInterest.join(","));
    formData.append("areaofstudy", this.selectedToStudy.join(","));
    formData.append("vartical_ids", this.selectedToVertical.join(","));
    formData.append("sector_of_business", this.selectedTo.join(","));
    formData.append("state", this.video.state);
    formData.append("city", this.video.city);
    formData.append("home_display", this.video.home_display);
    formData.append("is_active", this.video.is_active);
    formData.append("video_url", this.video.video_url);

    if (val.id == "") {
      if (this.fileList != undefined) {
        let file: File = this.fileList[0];
        formData.append("video_file", this.croppedVideo);
      } else {
        formData.append("video_file", "");
      }

      if (this.fileList1 != undefined) {
        let file1: File = this.fileList1[0];
        formData.append("video_thumb", this.video.video_thumb);
      } else {
        formData.append("video_thumb", "");
      }
      this.dataService
        .saveNew(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.modalReference.close();
              this.allVideo();
              this.alertService.success("Video saved successfully", true);
              this.croppedVideo = "";
              this.fileList1 = "";
            } else if (data["status"] == 422) {
              this.loadHide();

              if (data["mesg"]["video_url"]) {
                this.alertService.error(data["mesg"]["video_url"]);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              } else if (data["mesg"]["video_file"]) {
                this.alertService.error(data["mesg"]["video_file"]);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              } else {
                this.alertService.error("Server Error");
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              }
            }
          },
          (error) => {
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    } else {
      formData.append("id", val.id);
      if (this.croppedVideo == null || this.croppedVideo == "") {
        formData.append("video_file", "");
      } else {
        formData.append("video_file", this.croppedVideo);
      }

      if (this.fileList1 != undefined) {
        let file1: File = this.fileList1[0];

        // ✅ Only append video_thumb if changed (base64 is new, not same as original)
        if (this.video.video_thumb !== this.originalThumb) {
          formData.append("video_thumb", this.video.video_thumb);
        } else {
          formData.append("video_thumb", "");
        }
      } else {
        formData.append("video_thumb", "");
      }

      this.dataService
        .videoNewUpdate(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.modalReference.close();
              // this.dtTrigger = new Subject(); //  DataTable
              this.allVideo();
              this.alertService.success("Video updated successfully", true);
            } else if (data["status"] == 422) {
              this.loadHide();
              if (data["mesg"]["video_url"]) {
                this.alertService.error(data["mesg"]["video_url"]);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              } else if (data["mesg"]["video_file"]) {
                this.alertService.error(data["mesg"]["video_file"]);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              } else {
                this.alertService.error("Server Error");
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              }
            }
          },
          (error) => {
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    }
  }

  onVideoTypeChange(value: string) {
    if (value === "1") {
      this.video.video_file = "";
      this.fileList = "";
      this.DisplayedText = "";
      this.croppedVideo = "";
    } else if (value === "2") {
      this.video.video_file = "";
      this.video.video_url = "";
    }
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .videoDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("Video deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allVideo();
          } else {
            this.alertService.error("Server error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  fileChange(event: any) {
    if (this.video.video_file) {
      URL.revokeObjectURL(this.video.video_file);
    }

    this.video.video_file = "";
    this.fileList = event.target.files;
    let hasFile = this.fileList && this.fileList.length > 0;

    if (hasFile) {
      const file = this.fileList[0];
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      const validFileType = ".mp4,.ogg,.webm"; // removed spaces

      if (!validFileType.includes(extension)) {
        alert(
          "Please select a valid file type. Only .mp4, .ogg, .webm are allowed."
        );
        this.fileList = null;
        this.DisplayedText = "";
        return;
      }

      if (file.size > 100 * 1024 * 1024) {
        alert("File size is more than 100 MB");
        this.fileList = null;
        this.DisplayedText = "";
        return;
      }

      this.DisplayedText = file.name;
      this.croppedVideo = file;
      setTimeout(() => {
        this.video.video_file = URL.createObjectURL(file);
      }, 0);

      this.onSelection.emit(this.fileList);
    }
  }

  fileChange1(event: any) {
    this.fileList1 = event.target.files;
    let hasFile = this.fileList1 && this.fileList1.length > 0;

    if (hasFile) {
      const file: File = this.fileList1[0];
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      const validFileTypes = [".jpg", ".png", ".bmp"];

      if (!validFileTypes.includes(extension)) {
        alert("Please select a valid file type. Supported: .jpg, .png, .bmp");
        this.fileList1 = null;
        this.thumbnailDisplayedText = "";
        return false;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert("File size is more than 5 MB");
        this.fileList1 = null;
        this.thumbnailDisplayedText = "";
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.video.video_thumb = reader.result as string;
        this.thumbnailDisplayedText = file.name;
        this.onSelection.emit(this.fileList1);
      };
    }
  }

  pdfExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-pdf", "_blank");
  }
  xlExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-excel", "_blank");
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
